import { render, staticRenderFns } from "./StockJournalLines.vue?vue&type=template&id=5db5b220"
import script from "./StockJournalLines.vue?vue&type=script&lang=js"
export * from "./StockJournalLines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports